export default __webpack_public_path__ + "16ae00fcecae23a06e9d624708ddcf73.svg";